angular
  .module("admin.subscriptions")
  .controller("FreeplayList", function ($uibModal, FreePlayResource, $location, $timeout) {
    this.pagination = {
      page: 1,
      pageSize: 10,
    };

    this.freeplays = [];
    this.metadata = {};
    this.search = "";
    this.searchTimeout = null;

    const queryParams = $location.search();
    if (queryParams.search) {
      this.search = queryParams.search;
    }

    this.fetchData = function () {
      this.loading = true;
      var params = {
        page: this.pagination.page,
        limit: this.pagination.pageSize,
      };

      if (this.search) {
        params.search = this.search;
      }

      FreePlayResource.query(params, (response) => {
        this.loading = false;
        if (response && response.data) {
          this.freeplays = response.data.data || [];
          this.metadata = response.data.metadata || {};
          return;
        }
        this.freeplays = [];
        this.metadata = {};
      });
    };

    this.onSearchChange = function () {
      this.loading = true;
      if (this.searchTimeout) {
        $timeout.cancel(this.searchTimeout);
      }
      this.pagination.page = 1;
      
      if (this.search) {
        $location.search({ search: this.search });
      } else {
        $location.search({});
      }
      
      this.searchTimeout = $timeout(() => {
        this.fetchData();
      }, 500);
    };

    this.openCreate = function (fp) {
      $uibModal
        .open({
          controller: "FreeplayEdit",
          controllerAs: "ctrl",
          templateUrl: "views/freeplay/edit.html",
          backdrop: "static",
          resolve: {
            fp: () => null,
          },
        })
        .result.then(() => {
          this.fetchData();
        });
      return false;
    };

    this.openEdit = function (fp, e) {
      e.preventDefault();
      $uibModal
        .open({
          controller: "FreeplayEdit",
          controllerAs: "ctrl",
          templateUrl: "views/freeplay/edit.html",
          backdrop: "static",
          resolve: {
            fp: () => fp,
          },
        })
        .result.then(() => {
          this.fetchData();
        });
      return false;
    };

    this.openDelete = function (freeplay, e) {
      e.preventDefault();
      var modal = $uibModal.open({
        templateUrl: "views/freeplay/delete.html",
        controller: function ($uibModalInstance, fp, FreePlayResource) {
          this.close = function () {
            FreePlayResource.delete(fp, () => {
              $uibModalInstance.close();
            });
          };
          this.dismiss = function () {
            $uibModalInstance.dismiss();
          };
        },
        controllerAs: "ctrl",
        resolve: {
          fp: () => freeplay,
        },
      });

      modal.result.then(() => {
        this.fetchData();
      });

      return false;
    };

    this.fetchData();
  })
  .config(function ($stateProvider) {
    $stateProvider.state("admin.freeplays", {
      controller: "FreeplayList",
      controllerAs: "ctrl",
      templateUrl: "views/freeplay/list.html",
      url: "freeplay",
      data: {
        permissions: {
          only: "subscription.freeplay.view",
          redirectTo: "admin",
        },
      },
    });
  });
